import { IRedactedUser } from "@wingspanhq/users/dist/lib/interfaces";
import { selectorUserLegalName } from "./selectorUserLegalName";

export const selectorRedactedUserName = (user: IRedactedUser) =>
  `${selectorUserLegalName(user)} ${
    (user?.profile as any)?.preferredName
      ? `(${(user?.profile as any)?.preferredName})`
      : ""
  }`.trim();
